<div class="system-wrapper">
@let s = this.system();
@if (s != undefined) {
    @let mbIos = s.getIOs();
    <div>
        <div class="rack">
            <div class="rack-label">{{'Mainboard' | translate: 'Mainboard'}}</div>
        </div>
        <div class="mainboard">
            <div>{{s.mainboard.label}}</div>
            <hdw-io-selector [ios]="mbIos" [initialSelection]="this.initialSelection()" 
                [presentation]="'horizontal'" [kanaalMap]="this.kanaalMap()" (onKanaalSelected)="this.onSelectionChange($event)"></hdw-io-selector>
        </div>    
    </div>
    @let buses = s.getBusTypes();
    @for (bus of buses; track bus) {
        <div class="rack-wrapper">
            <div>{{bus}}</div>
            @let racks = s.getRacks(bus);
            @for (rack of racks; track rack) {
                @let karten = rack.kaarten;
                <div class="rack">
                    <div class="rack-label">{{rack.type.label}} {{rack.type.hideNumber ? "" : rack.number}} </div>
                    <div class="rack-content">
                        @for (kart of karten; track kart) {
                            @if (kart.type.takesRackSpace) {
                                <div class="kaart">
                                    @let kIos = kart.getIOs();
                                    @let emptyKart = kIos.length == 0;
                                    <div class="kaart-label" [class.system-kart-label]= "emptyKart">{{kart.type.label}}({{kart.number}})</div>
                                    @let isHorisontal = (kart.type.metaId == "scx_900");
                                    <hdw-io-selector [ios]="kIos" [initialSelection]="this.initialSelection()"
                                    [presentation]="isHorisontal ? 'horizontal' : 'vertical'"
                                    (onKanaalSelected)="this.onSelectionChange($event)" [kanaalMap]="this.kanaalMap()"></hdw-io-selector>
                                </div>
    
                            }
                        }
                    </div>
                </div>
            }
        </div>
    }
    <div class="rack">
        <div class="rack-label">{{'Virtuele IOs' | translate: 'Virtuele IOs'}}</div>
        <div class="rack-content">
            @let mbi = this.extras()['MBI'];
            @if (mbi != undefined && mbi.length > 0) {
                <hdw-io-list [ios]="mbi" label="{{'ModBus IN' | translate: 'ModBus IN'}}"></hdw-io-list>
            }
            @let mbo = this.extras()['MBO'];
            @if (mbo != undefined && mbo.length > 0) {
                <hdw-io-list [ios]="mbo" label="{{'ModBus OUT' | translate: 'ModBus OUT'}}"></hdw-io-list>
            }
            @let mqtti = this.extras()['MQTTI'];
            @if (mqtti != undefined && mqtti.length > 0) {
                <hdw-io-list [ios]="mqtti" label="{{'MQTT IN' | translate: 'MQTT IN'}}"></hdw-io-list>
            }
            @let mqtto = this.extras()['MQTTO'];
            @if (mqtto != undefined && mqtto.length > 0) {
                <hdw-io-list [ios]="mqtto" label="{{'MQTT OUT' | translate: 'MQTT OUT'}}"></hdw-io-list>
            }
        </div>
    </div>
    @if (this.hasOutOfRange()) {
        <div class="rack">
            <div class="rack-label">{{'Out of Range' | translate: 'Out of Range'}}</div>
                <div class="rack-content">
                @let oorAI = this.hdwOutOfRange()['AI'];
                @if (oorAI != undefined && oorAI.length > 0) {
                    <hdw-io-list [ios]="oorAI" label="{{'AI Out of Range' | translate: 'AI Out of Range'}}"></hdw-io-list>
                }
                @let oorAO = this.hdwOutOfRange()['AO'];
                @if (oorAO != undefined && oorAO.length > 0) {
                    <hdw-io-list [ios]="oorAO" label="{{'AO Out of Range' | translate: 'AO Out of Range'}}"></hdw-io-list>
                }
                @let oorDI = this.hdwOutOfRange()['DI'];
                @if (oorDI != undefined && oorDI.length > 0) {
                    <hdw-io-list [ios]="oorDI" label="{{'DI Out of Range' | translate: 'DI Out of Range'}}"></hdw-io-list>
                }
                @let oorDO = this.hdwOutOfRange()['DO'];
                @if (oorDO != undefined && oorDO.length > 0) {
                    <hdw-io-list [ios]="oorDO" label="{{'DO Out of Range' | translate: 'DO Out of Range'}}"></hdw-io-list>
                }
                
            </div>
        </div>
    }

}

</div>